var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M55.4998 35.8355C55.4998 43.508 49.3398 49.723 41.6673 49.7505H41.6398H14.3873C6.74226 49.7505 0.499756 43.563 0.499756 35.8905V35.863C0.499756 35.863 0.516256 23.6915 0.538256 17.57C0.541006 16.4205 1.86101 15.777 2.76026 16.492C9.29426 21.6757 20.979 31.1275 21.1248 31.2512C23.0773 32.816 25.5523 33.6987 28.0823 33.6987C30.6123 33.6987 33.0873 32.816 35.0398 31.221C35.1855 31.1247 46.609 21.9562 53.242 16.6872C54.144 15.9695 55.4695 16.613 55.4723 17.7597C55.4998 23.8345 55.4998 35.8355 55.4998 35.8355Z",
    fill: "#1ECD79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.059 7.60228C51.6775 3.11428 46.9915 0.248779 41.8325 0.248779H14.3875C9.22855 0.248779 4.54255 3.11428 2.16105 7.60228C1.62755 8.60603 1.88055 9.85728 2.7688 10.5668L23.1875 26.899C24.6175 28.054 26.35 28.6288 28.0825 28.6288C28.0935 28.6288 28.1018 28.6288 28.11 28.6288C28.1183 28.6288 28.1293 28.6288 28.1375 28.6288C29.87 28.6288 31.6025 28.054 33.0325 26.899L53.4513 10.5668C54.3395 9.85728 54.5925 8.60603 54.059 7.60228Z",
    fill: "#1ECD79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailGreen);
export default __webpack_public_path__ + "static/media/mail-green.0cc01d56ad65cf1d8e5af231f8aa0f35.svg";
export { ForwardRef as ReactComponent };